import getPageName from "./getPageName";

const partners = () => {
    if (getPageName() != "partners") return;

    const tabs = document.querySelectorAll('.partners-catalog__tab button');
    const programs = document.querySelectorAll('.partners-catalog__program');
    let activeTab = document.querySelector(".partners-catalog__tab button.active");

    if (tabs.length && programs.length ) {
        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                if (!tab.classList.contains("active")) {
                    let attr = tab.getAttribute('data-partners-catalog');
                    tab.classList.add('active');
                    activeTab.classList.remove('active');
                    activeTab = tab;

                    if (attr == 'all') {
                        programs.forEach(program => {
                            program.style.display = 'block';
                        });
                    } else {                    
                        programs.forEach(program => {
                            if (program.getAttribute('data-partners-program') == attr) {
                                program.style.display = 'block';
                            } else {                                
                                program.style.display = 'none';
                            }
                        });
                    }
                }
            })
        })
    }
    
}

export default partners;